// import Vue from 'vue'

export default function ({route, app, store, redirect, root}) {
  /*if (route.path.includes('/user') && route.path !== '/user-confirm'  && !store.getters.token) {
    redirect('/sign-in')
  }*/

  if (!store.getters.getUserInfo && (route.path === ('/profile/')
    || route.path === ('/profile')
    || route.path === ('/profile/')
    || route.path === ('/profile/shipping-addresses')
    || route.path === ('/profile/orders'))) {
    redirect('/403')
  }
}
